import bg_home from 'assets/images/bg_home.png';
import HeaderMenu from 'components/Header/HeaderMenu';
import { SITE } from 'config/config';
import { twMerge } from 'tailwind-merge';
import MatchResult from './MatchResult';

const PrizeStructure = () => {
  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src={bg_home}
        alt="Background"
        className="h-full w-full fixed right-0 bottom-0 object-cover"
      />
      <div className="relative z-10 pb-5">
        <HeaderMenu />
        <div className="container relative z-10">
          <div className="w-full max-w-[1200px] mx-auto h-auto flex justify-center items-center">
            <img
              src="/assets/images/header/bannerpc.png"
              alt=""
              className="w-full h-auto object-contain md:flex hidden"
            />
            <img
              src="/assets/images/header/bannermb.png"
              alt=""
              className="w-full h-auto object-contain py-2 md:hidden flex"
            />
          </div>
          <MatchResult />
        </div>
      </div>{' '}
    </div>
  );
};

export default PrizeStructure;
